import axios from "axios";
import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// トスアップフォーム-チャットアプリ連携-依存選択肢一覧取得（accessDB2）
export async function getTossUpFormChatAppDependSelects(id: string) {
  try {
    const path = "tossUpFormChatAppDependSelects";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, { params });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
  }
}

// トスアップフォーム-チャットアプリ連携-依存選択肢詳細取得
export async function getTossUpFormChatAppDependSelect(id: string) {
  try {
    const path = "tossUpFormChatAppDependSelect";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, { params });
    if (response.data.detail_data && response.data.detail_data.length > 0) {
      return response.data.detail_data[0];
    }
    return null;
  } catch (error) {
    return null;
  }
}

// トスアップフォーム-チャットアプリ連携-依存選択肢編集
export async function putTossUpFormChatAppDependSelect(editData: EditDataDifine) {
  try {
    const path = "tossUpFormChatAppDependSelect";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl2 + path, { params, bodys });
    return response.data.edit;
  } catch (error) {
    return undefined;
  }
}

// トスアップフォーム-チャットアプリ連携-依存選択肢登録
export async function postTossUpFormChatAppDependSelect(addData: {
  [key: string]: string | number | boolean | unknown[];
}) {
  try {
    const path = "tossUpFormChatAppDependSelect";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, { bodys });
    return response.data.add;
  } catch (error) {
    return undefined;
  }
}

// トスアップフォーム-チャットアプリ連携-依存選択肢削除
export async function deleteTossUpFormChatAppDependSelect(id: string) {
  try {
    const path = "tossUpFormChatAppDependSelect";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, { params });
    return response.data.delete;
  } catch (error) {
    return undefined;
  }
}

// トスアップフォーム-質問・選択肢一覧（依存追加モーダル用）
export async function getTossUpFormOptionsForChatAppDepend(tossUpFormId: string) {
  try {
    const path = "tossUpFormOptionsForChatAppDepend";
    const params = { id: tossUpFormId };
    const response = await axios.get(CONST.apiUrl2 + path, { params });
    return response.data.fetch_data || [];
  } catch (error) {
    return [];
  }
}
